import AccountStats from '@/features/account/components/account-stats';
import WatchList from '@/features/portfolio/components/watch-list/watch-list';
import useViewport from '@/hooks/use-viewport';
import { cn } from '@/lib/utils';
import { ChevronLeft } from '@/components/icons/barrel';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '@/config/routes';
//  lg:min-w-[348px]
export default function Sidebar() {
  const { pathname } = useLocation();
  const [isExpanded, setIsExpanded] = useState(
    window.innerWidth >= 1280 && pathname !== ROUTES.CUSTOM_NETWORK_WITHDRAW,
  );

  useViewport((_v, width) =>
    setIsExpanded(width >= 1280 && pathname !== ROUTES.CUSTOM_NETWORK_WITHDRAW),
  );

  return (
    <div
      style={{
        maxWidth: isExpanded ? 288 : 0,
      }}
      className="fixed bottom-0 left-0 top-0 z-30 w-full bg-background transition-all xl:relative xl:w-full xl:max-w-none"
    >
      <div className="relative z-10 flex h-full w-full shrink-0 flex-col overflow-x-auto border-r border-border bg-background pt-[128px] xl:pt-0">
        <AccountStats />
        <div className="relative min-h-0 flex-1">
          <div className="no-scrollbar absolute inset-0 h-full w-full overflow-y-auto">
            <WatchList />
          </div>
        </div>
      </div>
      <button
        className={cn(
          'absolute bottom-1/2 left-full flex h-16 items-center justify-center gap-1 rounded-r border-y border-r border-border bg-background pl-2 pr-1 shadow transition-transform hover:translate-x-0 xl:h-12',
          isExpanded ? '-translate-x-11' : '-translate-x-12',
        )}
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        <span className="mb-0.5 block leading-none">
          {isExpanded ? 'Hide' : 'Show'}
        </span>
        <ChevronLeft
          className={cn(
            'size-6 transition-transform',
            isExpanded ? 'rotate-0' : 'rotate-180',
          )}
        />
      </button>
    </div>
  );
}
